import { useQuery } from '@tanstack/react-query';
import { IBatchConfig } from '../../utils/types';
import { apiClient } from '../api-manager-instance';
import { ENDPOINTS } from '../endpoints';

export const useGetBatchConfigs = () =>
  useQuery({
    queryKey: ['get_batch_configs'],
    queryFn: async (): Promise<{ success: boolean; data: IBatchConfig }> => {
      const res = await apiClient.get(ENDPOINTS.BATCH_CONFIGS.GET);
      return res.data;
    },
  });
